interface Props {
   children: React.ReactNode;
}
export default function TableData({ children }: Props) {
   return <td className="px-4 py-3">{children}</td>;
}
